import { BaseEntity } from "yt-ng-framework";

export class PodVrstaDokumentaStavka extends BaseEntity{
    constructor(){
        super();
    }

    VrstaDokumentaID: number = null;
    PodVrstaDokumentaID:number = null;
    Naziv:string = null;    
    Sifra:string = null;
    Aktivan:boolean = false;
    OdgovornoLiceID:number = null;
    Footer1:string = null;
    FormatBrojaDokumenta: string = null;
    DuzinaBrojaDokumenta: number = null;
    PrimerBrojaDokumenta: string = null;
    BankaID: number = null;
    DefaultIzvestajID: number = null;
    BrojDecimala: number = 0;

    Deserialize(input:any){
        this.ID=input.ID;
        this.VrstaDokumentaID = input.VrstaDokumentaID;
        this.PodVrstaDokumentaID=input.PodVrstaDokumentaID;
        this.Naziv=input.Naziv;        
        this.Sifra=input.Sifra;
        this.Aktivan=input.Aktivan;
        this.OdgovornoLiceID=input.OdgovornoLiceID;
        this.Footer1=input.Footer1;
        this.FormatBrojaDokumenta=input.FormatBrojaDokumenta;
        this.DuzinaBrojaDokumenta = input.DuzinaBrojaDokumenta;
        this.PrimerBrojaDokumenta = input.PrimerBrojaDokumenta;
        this.BankaID = input.BankaID;
        this.DefaultIzvestajID = input.DefaultIzvestajID;
        this.BrojDecimala = input.BrojDecimala;
     return this;
    }

    Serialize(input:PodVrstaDokumentaStavka){
        return input;
    }
}